export default "__VITE_ASSET__BrAxvE61__"